// prettier-ignore
export class RoutesConstants {
    public static BASE_AUTH_REDIRECT = `/login`;
    public static OVERVIEW_DASHBOARD = `/overview-dashboard`;
    public static COMPANY_DASHBOARD = (id: string) => `/company/${id}/dashboard`;
    public static COMPANY_ANALYTICS_DASHBOARD = (id: string) => `/company/${id}/analytics-dashboard`;
    public static CHOOSE_COMPANY = `/choose-company`;
    public static NO_COMPANIES = `/no-companies`;
}
